import React, { useRef, useState, useCallback, useEffect } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { NavLink } from '../../../lib/Navigation';
import './css/css.less';
import GameTags from '../game/GameTags';

const PULL_THRESHOLD = 45; // 触发“松手查看更多”的拉动阈值

const HorizontalScrollGame = (props) => {
  const scrollContentRef = useRef(null);
  const scrollContainerRef = useRef(null); // 指向滚动容器
  const wrapperRef = useRef(null); // 指向视口包裹容器

  const [seeMoreWidth, setSeeMoreWidth] = useState(0);
  const [indicatorText, setIndicatorText] = useState('左滑查看更多');
  const [shouldRotate, setShouldRotate] = useState(false);
  
  const currentWidthRef = useRef(0);

  const games = props.item.list || [];

  const handleScroll = useCallback(() => {
    if (!scrollContentRef.current || !wrapperRef.current || !scrollContainerRef.current) return;

    const content = scrollContentRef.current;
    const wrapper = wrapperRef.current;
    
    // 获取最后一个游戏元素
    const lastGameItem = content.lastElementChild;
    if (!lastGameItem) return;

    // 获取视口容器和最后一个元素的边界信息
    const wrapperRect = wrapper.getBoundingClientRect();
    const lastItemRect = lastGameItem.getBoundingClientRect();
    
    // 计算最后一个元素的右边缘与视口容器右边缘的距离
    // 容器右侧有 16px 的默认 margin/padding，所以我们用 wrapperRect.right - 16 作为基准
    const targetRight = wrapperRect.right - 16;
    const gap = targetRight - lastItemRect.right;
    
    // 宽度就是这个 gap，只在 gap > 0（即最后一个项目由于橡皮筋回弹被往左拉，离开右边缘）时才变宽
    const width = Math.max(0, gap);
    
    setSeeMoreWidth(width);
    currentWidthRef.current = width;

    if (width >= PULL_THRESHOLD) {
      setIndicatorText('松手查看更多');
      setShouldRotate(true);
    } else {
      setIndicatorText('左滑查看更多');
      setShouldRotate(false);
    }
  }, []);

  const handleRelease = useCallback(() => {
    if (currentWidthRef.current >= PULL_THRESHOLD) {
      if (props.onSeeMore) {
        setTimeout(() => {
          props.onSeeMore();
        }, 300);
      }
    }
  }, [props.onSeeMore]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      // 初始化位置
      handleScroll(); 
      scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
      
      // 使用ResizeObserver来应对窗口大小变化或动态内容
      const resizeObserver = new ResizeObserver(handleScroll);
      resizeObserver.observe(scrollContainer);
      if (scrollContentRef.current) {
        resizeObserver.observe(scrollContentRef.current);
      }

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
        resizeObserver.disconnect();
      };
    }
  }, [handleScroll, games]); // 当游戏列表数据变化时，重新设置监听

  return (
    <div 
      className="h-scroll-game-row-container"
      onTouchEnd={handleRelease}
      onMouseUp={handleRelease}
    >
      <div 
        className="h-scroll-game-wrapper"
        ref={wrapperRef}
      >
        <div 
          className="h-scroll-game-container" 
          ref={scrollContainerRef}
        >
          <div className="h-scroll-content" ref={scrollContentRef}>
            {games.map((game, index) => (
              <NavLink user={false} to={`game?id=${game.game_id}`} key={index} className="game-item">
                <img src={game.game_image.thumb} alt={game.game_name} className="game-icon" />
                <p className="game-name">{game.game_name}</p>
                <div style={{paddingLeft: '5px'}}>
                  <GameTags game={game}></GameTags>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>
      <div 
        className="see-more-container" 
        style={{ width: `${seeMoreWidth}px` }}
      >
        <div className="see-more-content-inner">
          <LeftOutlined 
            className="see-more-icon" 
            style={{ transform: shouldRotate ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}
          />
          <p className="see-more-text">{indicatorText}</p>
        </div>
      </div>
    </div>
  );
};

export default HorizontalScrollGame;
